import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { useIntl } from 'react-intl';

import deleteIcon from '../../../../../../../../public/static/books/delete.png';

import css from './BooksSelectedDateTime.module.scss';

interface Props {
  date: string;
  startTime: string;
  endTime: string;
  value: number;
  withBorder?: boolean;
  onTimeSlotClick: (() => void) | null;
  onDeleteClick: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
}

const BooksSelectedDateTime = ({
  date,
  startTime,
  endTime,
  value,
  withBorder,
  onTimeSlotClick,
  onDeleteClick,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(
    css.BooksSelectedDateTime,
    withBorder ? css.withBorder : '',
  );

  return (
    <div
      className={classes}
      onClick={onTimeSlotClick ? onTimeSlotClick : undefined}
    >
      {intl.formatDate(df.format(date), {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short',
      })}
      <span className={css.BooksSelectedDateTime__Time}>
        {startTime}
        <span> - </span>
        {endTime}
      </span>
      {onDeleteClick && (
        <button
          className={css.BooksSelectedDateTime__Button}
          onClick={onDeleteClick}
          value={value}
        >
          <img
            className={css.BooksSelectedDateTime__Icon}
            src={deleteIcon}
            alt="Delete icon"
          />
        </button>
      )}
    </div>
  );
};

export default BooksSelectedDateTime;
